export default "__VITE_ASSET__D3TgCt8$__"